package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.presentation.viewmodel.HistoryViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun HistoryScreen(vm: HistoryViewModel, onPlay: OnPlay) {
    val state by vm.state.collectAsState()

    PageContainer {
        H2(attrs = { style { property("margin", "0 0 16px") } }) { Text("Watch history") }
        if (state.isLoading && state.history.isEmpty()) {
            Spinner()
        } else if (state.history.isEmpty()) {
            EmptyState("Nothing watched yet.")
        } else {
            state.history.forEach { h ->
                RowItem(
                    name = h.contentName,
                    imageUrl = h.contentLogoUrl,
                    subtitle = h.contentType.name.lowercase().replaceFirstChar { it.uppercase() },
                    onClick = { onPlay(h.contentId, h.contentName, h.streamUrl, h.contentType, h.contentLogoUrl) },
                ) {
                    GhostButton("Remove") { vm.removeHistory(h.contentId) }
                }
            }
        }
    }
}
